import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { CloudIdStorageService } from "./cloud-id-storage.service";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable({
  providedIn: "root",
})
export class CloudGuard implements CanActivate {
  get selectCloudEnabled() {
    return this.configurationService.selectCloud;
  }

  constructor(
    private cloudStorageService: CloudIdStorageService,
    private router: Router,
    private configurationService: ConfigurationService
  ) {}

  canActivate(childRoute, state) {
    if (this.selectCloudEnabled) {
      if (this.loadCloudId()) {
        return this.cloudSelectedState();
      } else {
        return this.cloudSelectionState();
      }
    } else {
      return true;
    }
  }

  loadCloudId() {
    return this.cloudStorageService.loadCloudId();
  }

  storeCloudId(cloudId) {
    this.cloudStorageService.storeCloudId(cloudId);
  }

  cloudSelectionState() {
    return this.router.parseUrl("/clouds");
  }

  cloudSelectedState() {
    return true;
  }
}
